import { Injectable } from '@angular/core'
import { HttpRequest, HttpHandler, HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpInterceptor } from '@angular/common/http'
import { throwError, Observable } from 'rxjs'
import { catchError, flatMap } from 'rxjs/operators'
import { NGXLogger } from 'ngx-logger'
import { ACCOUNT_AUTH_GROUP, NINTH_WAVE_GROUP } from '../../modules/account/account-api'
import { ModalStateService } from 'src/app/core/services/modal-state.service'
import { UserProps } from '../../modules/account/services/api/additional/UserProps'
import { LoginService } from '../../modules/account/services/api/login.service'
import { NinthWaveProps } from '../../modules/account/services/api/additional/NinthWaveProps'
import { NinthWaveAuthThirdPartyService } from '../../modules/account/services/api/ninthwave/ninthwave-auth-tp.service'


@Injectable()
export class NinthWaveAuthInterceptorExtension implements HttpInterceptor {
  constructor(
    public logger: NGXLogger,
    // public ninthWaveAuthService: NinthWaveAuthService,
    public ninthWaveAuthService: NinthWaveAuthThirdPartyService,
    private modalStateService: ModalStateService,
    ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<
    | HttpSentEvent
    | HttpHeaderResponse
    | HttpProgressEvent
    | HttpResponse<any>
    | HttpUserEvent<any>
  > {
    const userProps = this.ninthWaveAuthService.getNinthWaveProps()
    const ninthToken = userProps.ninthWaveTokenString
    if (ninthToken) {
      request = this.attachToken(request, ninthToken)
    }

    return this.renewTokenOnError(next, request)

  }

  private renewTokenOnError(next, request) {
    return next.handle(request).pipe(
      catchError((err) => {

        // console.log(err.message)
        if (err.status === 401 || err.status === 403 || err.status === 500
          ) {


          this.ninthWaveAuthService.refreshAuth()
          .subscribe(res => {
            const userProps = this.ninthWaveAuthService.getNinthWaveProps()


            // TODO: solve refreshing
            // tslint:disable-next-line: tsr-detect-possible-timing-attacks
            request = userProps?.ninthWaveTokenString !== undefined
                    ? this.attachToken(request, userProps.ninthWaveTokenString)
                    : request


            return next.handle(request)
          })
        }
        return throwError(err)
      })
    )
  }


  private attachToken(request: HttpRequest<any>, accessToken) {
    // if (request.url.search(ACCOUNT_AUTH_GROUP.AUTH_THIRD_PARTY) === -1) {
    request = request.clone({
      setHeaders: {
        Authorization: `${accessToken}`,
      },
    })
    // }
    return request
  }

}
